export default [
    {
        name: 'Pleitos',
        url: '/pleitos/uai',
        icon: 'fa fa-file-text-o',
        regras: 'PLEITOS-UAI-00',
        badge: {
            variant: 'primary',
            text: 'UAI'
        }
    }
]